import {Component, Input, OnInit, Optional, TemplateRef, ViewChild} from '@angular/core';
import {OrderDetail, OrderModel} from '@modules/administration/orders/interfaces/order.model';
import {NzModalRef} from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-print-order',
    templateUrl: './print-order.component.html',
    styleUrls: ['./print-order.component.css']
})
export class PrintOrderComponent implements OnInit {
    @Input() data: OrderModel[];
    @ViewChild('editFooter') editFooter: TemplateRef<any>;
    orderDetail: OrderDetail[] = [];

    constructor(
        @Optional() private modalRef: NzModalRef,
    ) {
    }

    ngOnInit(): void {
        this.generateOrderDetail();
    }

    ngAfterViewInit(): void {
        Promise.resolve().then(() => {
            this.modalRef?.updateConfig({
                nzFooter: this.editFooter
            });
        });
    }

    onPrint() {
        this.modalRef?.close(true);
    }

    generateOrderDetail() {
        if (this.data && Array.isArray(this.data)) {
            this.data.forEach(order => {
                const regex = /([^|#]+)\|(\d+)\|(\d+)/g;
                let match: RegExpExecArray | null;

                const orderDetails: OrderDetail[] = [];

                while ((match = regex.exec(order.product)) !== null) {
                    orderDetails.push({
                        productDetail: match[1],
                        quantity: parseInt(match[2], 10),
                        price: parseInt(match[3], 10),
                        subTotal: null
                    });
                }

                // Attach parsed orderDetails back to each order
                (order as any).orderDetail = orderDetails;
            });
        }
    }


}
